angular.module('gym.components').directive('editFormSection', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/edit_form_section.html.slim'),
    scope: {
      form: '=',
      formValue: '=',
      save: '&',
      cancel: '&'
    },
    controller: ["$scope", "$rootScope", "$stateParams", "FormFieldDisplayingService", function($scope, $rootScope, $stateParams, FormFieldDisplayingService) {
      $scope.isFieldAvailable = function(field) {
        var contactType;
        contactType = $stateParams.contactType.slice(0, -1);
        return FormFieldDisplayingService.isDisplaying(contactType, field);
      };
      return $scope.units = $rootScope.gym.units;
    }]
  };
});
